export default {
  home: "Home",
};
